import Component from '@glimmer/component';
import { t } from 'ember-intl';
import WLoginDialog from 'login/components/w-login-dialog';
import type { ApplicationModel } from 'login/routes/application';

export default class Expired extends Component<{ Args: { model: ApplicationModel } }> {
  <template>
    <WLoginDialog
      @pageTitle={{t 'login.title.expired'}}
      @dialogTitle={{@model.logonParams.serviceName}}
      @version={{@model.version}}
    >
      <div class='centered-line'>
        {{t 'login.expired'}}
      </div>
    </WLoginDialog>
  </template>
}
